var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeamsSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8793 9.9102C22.2341 9.9102 16.9536 11.2278 16.9536 13.873V14.1548H32.8049V13.873C32.8049 11.2278 27.5244 9.9102 24.8793 9.9102ZM24.8793 7.92879C25.9303 7.92879 26.9382 7.51128 27.6814 6.76811C28.4246 6.02493 28.8421 5.01697 28.8421 3.96597C28.8421 2.91496 28.4246 1.907 27.6814 1.16383C26.9382 0.420654 25.9303 0.00314331 24.8793 0.00314331C23.8283 0.00314331 22.8203 0.420654 22.0771 1.16383C21.3339 1.907 20.9164 2.91496 20.9164 3.96597C20.9164 5.01697 21.3339 6.02493 22.0771 6.76811C22.8203 7.51128 23.8283 7.92879 24.8793 7.92879Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4189 15.8874C7.60758 15.8874 -0.000732422 17.7859 -0.000732422 21.5972V22.0031H22.8385V21.5972C22.8385 17.7859 15.2302 15.8874 11.4189 15.8874ZM11.4189 13.0325C12.9332 13.0325 14.3855 12.4309 15.4563 11.3601C16.5271 10.2893 17.1287 8.83702 17.1287 7.32269C17.1287 5.80836 16.5271 4.35604 15.4563 3.28525C14.3855 2.21445 12.9332 1.61288 11.4189 1.61288C9.90454 1.61288 8.45223 2.21445 7.38144 3.28525C6.31064 4.35604 5.70907 5.80836 5.70907 7.32269C5.70907 8.83702 6.31064 10.2893 7.38144 11.3601C8.45223 12.4309 9.90454 13.0325 11.4189 13.0325Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3486 4.54633L33.3486 9.44425",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7974 7.00098L30.8994 7.00098",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsSidebar);
export default __webpack_public_path__ + "static/media/teams_sidebar.c3d7e1df0fbd48a936cda40d2d959d6b.svg";
export { ForwardRef as ReactComponent };